<template>
  <div>
    <div class="panel-topnav container-fluid">
      <ul class="nav nav-tabs pull-left">
        <li>
          <h3 class="page-title">
            Investor Funnel
          </h3>
        </li>
      </ul>
      <div class="clearfix" />
    </div>
    <InvestorFunnel :editable="editable" />
  </div>
</template>

<script>
import InvestorFunnel from './InvestorFunnel.vue'

export default {
  components: { InvestorFunnel },
  props: {
    editable: { type: Boolean, default: false },
  },
}
</script>
